import { dataProps } from './properties'

export const setLeaveMasterList = (state, payload) => {
    state.list = payload
}    

export const setLeaveMasterData = (state, payload) => {
    state.props = payload
} 

export const resetLeaveMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveMaster/mutations.js